import {
  GAME_ID,
  TARGET_AREAS,
  TARGET_STATES,
  REDUX_ACTIONS,
} from '../../data/constants';

const initialState = {
  [`${TARGET_AREAS.LEFT}`]: TARGET_STATES.INACTIVE,
  [`${TARGET_AREAS.RIGHT}`]: TARGET_STATES.INACTIVE,
  [`${TARGET_AREAS.TRASH}`]: TARGET_STATES.INACTIVE,
};

const hoverTargetStateReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.START_DRAG: {
      return {
        [`${TARGET_AREAS.LEFT}`]: TARGET_STATES.AVAILABLE,
        [`${TARGET_AREAS.RIGHT}`]: TARGET_STATES.AVAILABLE,
        [`${TARGET_AREAS.TRASH}`]: TARGET_STATES.AVAILABLE,
      };
    }
    case REDUX_ACTIONS.SET_CURRENT_HOVER_TARGET: {
      const newState = {
        [`${TARGET_AREAS.LEFT}`]: TARGET_STATES.AVAILABLE,
        [`${TARGET_AREAS.RIGHT}`]: TARGET_STATES.AVAILABLE,
        [`${TARGET_AREAS.TRASH}`]: TARGET_STATES.AVAILABLE,
      };
      if (action.payload !== TARGET_AREAS.NONE) {
        newState[action.payload] = TARGET_STATES.HOVERED;
      }
      return newState;
    }
    case REDUX_ACTIONS.MAKE_SELECTION: {
      return initialState;
    }
    default:
      return state;
  }
};

export default hoverTargetStateReducer;
